import { render, staticRenderFns } from "./SalesPage.vue?vue&type=template&id=3e4a85b6&"
import script from "./SalesPage.vue?vue&type=script&lang=ts&"
export * from "./SalesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports